export const getPositionStatus = (playersVoted = [])=>{
    if(playersVoted?.length < 1) return 'portero';
    if(playersVoted?.length === 1) return 'central';
    if(playersVoted?.length === 2) return 'lateral';
    if(playersVoted?.length === 3) return 'contencion';
    if(playersVoted?.length ===4) return 'volante'
    return 'delantero'

}

export const getLabelToVote = (player, playersVoted)=>{
    if(player?.position === 'portero') return 'porteros'
    if(player?.position === 'defensa') return playersVoted?.length === 1 ? 'defensasCentral' : 'defensaLateral';
    if(player?.position === 'medio') return playersVoted?.length === 3 ? 'mediocampistas' : 'volantes'
    return 'delanteros' 

}
export const getTypeMedio = (goldenBall, id)=>{
    const isMedios = goldenBall?.medios?.find(medio => medio?._id === id)
    const isPatrones = goldenBall?.patrones?.find(medio => medio?._id === id);
    const isCopas = goldenBall?.copas?.find(copa => copa?._id === id);
    if(isMedios) return 'medios';
    if(isPatrones) return 'patrones';
    if(isCopas) return 'copas'
    return null

}

export const getCurrentMedio  = (goldenBall, id)=>{
    const isMedios = goldenBall?.medios?.find(medio => medio?._id === id)
    const isPatrones = goldenBall?.patrones?.find(medio => medio?._id === id);
    const isCopas = goldenBall?.copas?.find(copa => copa?._id === id);
    if(isMedios) return isMedios;
    if(isPatrones) return isPatrones;
    if(isCopas) return isCopas
    return 'hack'

}

export const phaseLabelMap = {
    "nominate": "nominatedPlayers",
    "eleven": "onceIdeal",
    "winner": "goldenBall"
}

export const adapterPositionLabel = {
    "portero": "porteros",
    "central": "defensasCentral",
    "lateral": "defensaLateral",
    "contencion": "mediocampistas",
    "volante": "volantes",
    "delantero": "delanteros"
}